import * as z from "zod/v4";

export const unsubscribeFromPostscriptWebhook = {
  name: "unsubscribeFromPostscriptWebhook" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
